import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { EDITOR_MENU_PROPS } from './editorLayers';

/**
 * Configurable action selector.
 *
 * @param {object} props
 * @param {string} props.value
 * @param {(value: string) => void} props.onChange
 * @param {Array<{
 *   value: string,
 *   label: string,
 *   disabled?: boolean,
 * }>} props.actions
 * @param {boolean} [props.disabled]
 * @param {string} [props.label]
 * @param {string} [props.labelId]
 */
export default function ActionSelector({
  value,
  onChange,
  actions = [],
  disabled = false,
  label = 'Button Action',
  labelId = 'action-type-label',
}) {
  return (
    <FormControl fullWidth>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        label={label}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        disabled={disabled}
        MenuProps={EDITOR_MENU_PROPS}
      >
        {actions.map((action) => (
          <MenuItem
            key={action.value}
            value={action.value}
            disabled={!!action.disabled}
          >
            {action.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
